module.exports = __webpack_public_path__ + "static/media/ic_calendar_prev2.01dd6670.svg";